import React from "react";
import { makeStyles } from "@mui/styles";
import Header from "components/Header/Header.js";
import HomeFooter from "components/Footer/HomeFooter.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import styles from '../styles/staticPages.js';
import { useTranslation } from "react-i18next";
import pageBg from "assets/img/driver2.jpg";

const dashboardRoutes = [];
const useStyles = makeStyles(styles);

export default function AboutUs(props) {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const classes = useStyles();
  const { ...rest } = props;

  return (
    <div className={classes.pageRoot}>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 80,
          color: "conecta2Light"
        }}
        {...rest}
      />
      <div
        className={classes.pageHeader}
        style={{ backgroundImage: `url(${pageBg})` }}
      >
        <div className={classes.contentWrap}>
          <div
            className={classes.glassCard}
            style={{ direction: isRTL === 'rtl' ? 'rtl' : 'ltr', textAlign: isRTL === 'rtl' ? 'right' : 'left' }}
          >
            <div className={classes.eyebrow}>CONOCE MÁS</div>
            <h1 className={classes.title}>
              {t('about_us')} <span>Conecta2</span>
            </h1>
            <div className={classes.underline} />
            <p className={classes.body}>{t('about_us_content2')}</p>
            <p className={classes.body}>{t('about_us_content1')}</p>
            <div className={classes.footerTag}>
              <div className={classes.footerTagLine} />
              <span>EN TODO COLOMBIA</span>
            </div>
          </div>
        </div>
        <HomeFooter />
      </div>
    </div>
  );
}
